import { makeStyles, theme } from '@focaldata/cin-ui-components'

const useStyles = makeStyles()({
  // Header toolbar: the globe is the same IconButton as the delete button, so give
  // it the delete button's exact vertical nudge (top -0.25) + right gap → it lines
  // up with the other header icons instead of floating above them.
  triggerHeader: {
    display: 'inline-flex',
    margin: theme.spacing(-0.25, 1.5, 0, 0)
  },
  // Row end-adornment (response option / matrix row): sit inline with the row's
  // other adornment icons, no toolbar-specific offset.
  triggerAdornment: {
    display: 'inline-flex',
    alignItems: 'center'
  },
  // Inherit the tooltip's own (light) text colour + font — the same look as every
  // other tooltip — and only stack the lines and bold the heading.
  tooltip: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2
  },
  tooltipHeading: {
    fontWeight: 600
  }
})

export default useStyles
